module.exports={
  "name": "pixi.js",
  "version": "3.0.2",
  "description": "Pixi.js is a fast lightweight 2D library that works across all devices.",
  "author": "Mat Groves",
  "contributors": [
    "Chad Engler <chad@pantherdev.com>",
    "Richard Davey <rdavey@gmail.com>"
  ],
  "main": "./src/index.js",
  "homepage": "http://goodboydigital.com/",
  "bugs": "https://github.com/GoodBoyDigital/pixi.js/issues",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/GoodBoyDigital/pixi.js.git"
  },
  "scripts": {
    "test": "gulp && testem ci",
    "docs": "jsdoc -c ./gulp/util/jsdoc.conf.json -R README.md"
  },
  "dependencies": {
    "async": "^0.9.0",
    "brfs": "^1.4.0",
    "eventemitter3": "^1.0.1",
    "object-assign": "^2.0.0",
    "resource-loader": "^1.5.2"
  },
  "devDependencies": {
    "browserify": "^9.0.8",
    "chai": "^2.2.0",
    "del": "^1.1.1",
    "gulp": "^3.8.11",
    "gulp-cached": "^1.0.4",
    "gulp-concat": "^2.5.2",
    "gulp-debug": "^2.0.1",
    "gulp-jshint": "^1.10.0",
    "gulp-mirror": "^0.4.0",
    "gulp-plumber": "^1.0.0",
    "gulp-rename": "^1.2.2",
    "gulp-sourcemaps": "^1.5.2",
    "gulp-uglify": "^1.2.0",
    "gulp-util": "^3.0.4",
    "ink-docstrap": "git+https://github.com/Pilatch/docstrap.git",
    "jsdoc": "^3.3.0-beta3",
    "jshint-summary": "^0.4.0",
    "minimist": "^1.1.1",
    "mocha": "^2.2.4",
    "require-dir": "^0.3.0",
    "run-sequence": "^1.0.2",
    "testem": "^0.8.2",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0",
    "watchify": "^3.1.2"
  },
  "browserify": {
    "transform": [
      "brfs"
    ]
  }
}
